var map = {
	"./icons/MasterCard.png": 8719,
	"./icons/Visa.png": 148,
	"./icons/btn-arrow-down-white.svg": 8304,
	"./icons/btn-arrow-down.webp": 6991,
	"./icons/btn-arrow-next.svg": 6564,
	"./icons/btn-arrow-up.webp": 4109,
	"./icons/btn-calender.svg": 3716,
	"./icons/btn-cart.svg": 6350,
	"./icons/btn-close-black-bold.svg": 511,
	"./icons/btn-close-black-normal.svg": 4473,
	"./icons/btn-close-modal.svg": 5753,
	"./icons/btn-close-white-normal.svg": 3368,
	"./icons/btn-home.svg": 8729,
	"./icons/btn-more.svg": 9835,
	"./icons/btn-search-bold.svg": 1511,
	"./icons/btn-search-normal.svg": 818,
	"./icons/btn-search-white.svg": 6511,
	"./icons/btn-top.svg": 4323,
	"./icons/btn-user.svg": 4911,
	"./icons/check.svg": 706,
	"./icons/checked.png": 4686,
	"./icons/ico_video.svg": 412,
	"./icons/icon-service-bathchair.svg": 3483,
	"./icons/icon-service-coinwashing.svg": 9954,
	"./icons/icon-service-congrats.svg": 6928,
	"./icons/icon-service-front.svg": 5674,
	"./icons/icon-service-guest.svg": 5897,
	"./icons/icon-service-ice.svg": 4338,
	"./icons/icon-service-meal.svg": 4650,
	"./icons/icon-service-room.svg": 619,
	"./icons/icon-service-shower.svg": 2664,
	"./icons/icon-service-stroller.svg": 6662,
	"./icons/icon-service-tour.svg": 7980,
	"./icons/icon-service-trans.svg": 4339,
	"./icons/icon-service-tube.svg": 1473,
	"./icons/icon-service-washing.svg": 2519,
	"./icons/icon-service-water.svg": 3298,
	"./icons/icon-service-wifi.svg": 358,
	"./icons/icon-swiper-play.svg": 4616,
	"./icons/icon-swiper-stop.svg": 5174,
	"./icons/loading-spinner.svg": 4828,
	"./icons/logo-off.png": 7502,
	"./icons/logo-on.png": 5614,
	"./icons/notChecked.png": 5970,
	"./icons/picker_arrow_next.svg": 8771,
	"./icons/picker_arrow_prev.svg": 7855,
	"./icons/radio.svg": 4236,
	"./icons/signout.svg": 2142,
	"./images/about-guam-01.jpg": 8784,
	"./images/about-guam-02.jpg": 7302,
	"./images/about-guam-03.jpg": 2983,
	"./images/about-saipan-01.jpg": 4570,
	"./images/about-saipan-02.jpg": 8523,
	"./images/about-saipan-03.jpg": 4818,
	"./images/aboutbg-01.jpg": 8260,
	"./images/aboutbg-02.jpg": 3262,
	"./images/aboutbg-03.jpg": 7476,
	"./images/background-01.webp": 6909,
	"./images/background-02.webp": 4880,
	"./images/background-03.webp": 5384,
	"./images/background-04.webp": 5438,
	"./images/background-05.webp": 3658,
	"./images/background-06.webp": 9082,
	"./images/background-07.webp": 5566,
	"./images/background-08.webp": 4135,
	"./images/background-09.webp": 2405,
	"./images/background-10.webp": 8518,
	"./images/background-11.webp": 9450,
	"./images/background-12.webp": 3136,
	"./images/background-13.webp": 5146,
	"./images/background-14.webp": 9575,
	"./images/background-15.webp": 1363,
	"./images/background-16.webp": 7534,
	"./images/credit-MasterCard.png": 154,
	"./images/credit-Visa.png": 202,
	"./images/fix-cloud.svg": 7318,
	"./images/fix-guam.svg": 2735,
	"./images/fix-saipan.svg": 6607,
	"./images/fix-siheky-bottom.svg": 4077,
	"./images/fix-tree.svg": 6470,
	"./images/golf-img1.jpg": 3621,
	"./images/golf-img2.jpg": 3951,
	"./images/golf-img3.jpg": 7565,
	"./images/golf-img4.jpg": 4256,
	"./images/guam-img1.jpg": 4255,
	"./images/guam-img10.jpg": 3155,
	"./images/guam-img11.jpg": 2776,
	"./images/guam-img12.jpg": 9294,
	"./images/guam-img13.jpg": 622,
	"./images/guam-img2.jpg": 1471,
	"./images/guam-img3.jpg": 7254,
	"./images/guam-img4.jpg": 1295,
	"./images/guam-img5.jpg": 176,
	"./images/guam-img6.jpg": 3048,
	"./images/guam-img7.jpg": 3647,
	"./images/guam-img8.jpg": 4365,
	"./images/guam-img9.jpg": 8262,
	"./images/itr-bird.svg": 6057,
	"./images/itr-bubble-big.webp": 466,
	"./images/itr-bubble-middle.webp": 1955,
	"./images/itr-bubble-small.webp": 7642,
	"./images/itr-circle.svg": 7018,
	"./images/itr-cloud.svg": 4259,
	"./images/itr-fish-01.svg": 8439,
	"./images/itr-fish-02.svg": 2869,
	"./images/itr-fish-03.svg": 5833,
	"./images/itr-pattern-01.svg": 380,
	"./images/itr-pattern-02.svg": 2332,
	"./images/itr-sunny.svg": 8855,
	"./images/itr-wave.svg": 7392,
	"./images/logo-off.png": 373,
	"./images/logo-on.png": 5003,
	"./images/map-guam.png": 2283,
	"./images/map-saipan.png": 5392,
	"./images/popup-01.webp": 156,
	"./images/popup-02.webp": 2700,
	"./images/popup-03.webp": 1091,
	"./images/title-illustration.webp": 1288,
	"./images/visual-video.mp4": 2585,
	"./video/communityVideo-1.mp4": 9235,
	"./video/communityVideo-10.mp4": 7074,
	"./video/communityVideo-11.mp4": 8283,
	"./video/communityVideo-12.mp4": 6648,
	"./video/communityVideo-13.mp4": 8494,
	"./video/communityVideo-14.mp4": 833,
	"./video/communityVideo-15.mp4": 7499,
	"./video/communityVideo-16.mp4": 4621,
	"./video/communityVideo-17.mp4": 3790,
	"./video/communityVideo-18.mp4": 4244,
	"./video/communityVideo-19.mp4": 9304,
	"./video/communityVideo-2.mp4": 8218,
	"./video/communityVideo-20.mp4": 8974,
	"./video/communityVideo-3.mp4": 403,
	"./video/communityVideo-4.mp4": 155,
	"./video/communityVideo-5.mp4": 3503,
	"./video/communityVideo-6.mp4": 1126,
	"./video/communityVideo-7.mp4": 7962,
	"./video/communityVideo-8.mp4": 9720,
	"./video/communityVideo-9.mp4": 9291
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7173;